import { render } from "./FetchView.vue?vue&type=template&id=774f7401&scoped=true"
import script from "./FetchView.vue?vue&type=script&lang=js"
export * from "./FetchView.vue?vue&type=script&lang=js"

import "./FetchView.vue?vue&type=style&index=0&id=774f7401&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774f7401"]])

export default __exports__